import gql from 'graphql-tag'
import {
    CreateProgramTagCategoryMutation,
    CreateProgramTagCategoryMutationVariables,
    CreateProgramTagMutation,
    CreateProgramTagMutationVariables,
    CreateShow,
    CreateShowContainerMutation,
    CreateShowContainerMutationVariables,
    CreateShowMutation,
    CreateShowMutationVariables,
    CreateTag,
    CreateTagCategory,
    DeleteProgramTagCategoryMutation,
    DeleteProgramTagCategoryMutationVariables,
    DeleteProgramTagMutation,
    DeleteProgramTagMutationVariables,
    DeleteShowContainerMutation,
    DeleteShowContainerMutationVariables,
    DeleteShowMutation,
    DeleteShowMutationVariables,
    ImportShowsMutation,
    ImportShowsMutationVariables, MutationUpdateAttendeeTagArgs,
    MutationUpdateProgramTagArgs,
    MutationUpdateProgramTagCategoryArgs,
    TagType, UpdateProgramTagMutation,
    UpdateShow,
    UpdateShowMutation,
    UpdateShowMutationVariables,
    UpdateShowsContainerMutation,
    UpdateShowsContainerMutationVariables
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Create show
const createShowMutation = gql`
    mutation createShow($input: CreateShow!) {
        createShow(data: $input) {
            id
        }
    }
`
export const createShow = (input: CreateShow) => {
    const query = graphql.createQuery<CreateShowMutation, CreateShowMutationVariables>(createShowMutation)
    return query({ input })
}

// Delete Show
const deleteShowMutation = gql`
    mutation deleteShow($filters: ShowFilter!) {
        deleteShows(filters: $filters)
    }
`
export const deleteShow = graphql.createQuery<
    DeleteShowMutation, DeleteShowMutationVariables
>(deleteShowMutation)

// Update Show
const updateShowMutation = gql`
    mutation updateShow($filters: ShowFilter!, $input: UpdateShow!) {
        updateShows(filters: $filters, data: $input) {
            id
            attachment
            attachmentName
            virtualImage
            image
        }
    }
`

export const updateShow = (id: number, input: UpdateShow) => {
    const query = graphql.createQuery<UpdateShowMutation, UpdateShowMutationVariables>(updateShowMutation)
    return query({ filters: { id }, input, })
}

export const updateShows = (presentationId: number, input: UpdateShow) => {
    const query = graphql.createQuery<UpdateShowMutation, UpdateShowMutationVariables>(updateShowMutation)
    return query({ filters: { virtualSpace: { id: presentationId } }, input, })
}

// Import Shows
const importShowsMutation = gql`
    mutation importShows($event: EventID!, $data: [ImportShow!]!) {
        importShows(event: $event, data: $data) {
            successCount
            errorCount
            errorItems {
                id
                message
                hiddenMessage
            }
        }
    }
`

export const importShows = (event, data) => {
    const query = graphql.createQuery<ImportShowsMutation, ImportShowsMutationVariables>(importShowsMutation)
    return query({ event, data })
}

// Show container (parent folder)
const createShowContainerMutation = gql`
    mutation createShowContainer($event: EventID!, $data: CreateShowContainer!) {
        createShowContainer(event: $event, data: $data) {
            id
        }
    }
`
export const createShowContainer = (input: CreateShowContainerMutationVariables) => {
    const query = graphql.createQuery<
        CreateShowContainerMutation, CreateShowContainerMutationVariables
    >(createShowContainerMutation)
    return query(input)
}

const updateShowContainerMutation = gql`
    mutation updateShowsContainer($data: UpdateShowContainer!, $id: Int!) {
        updateShowContainer(data: $data, id: $id) {
            id
        }
    }
`
export const updateShowContainer = ({ id, data }: UpdateShowsContainerMutationVariables) => {
    const query = graphql.createQuery<
        UpdateShowsContainerMutation, UpdateShowsContainerMutationVariables
    >(updateShowContainerMutation)
    return query({ id, data })
}

const deleteShowContainerMutation = gql`
    mutation deleteShowContainer($id: Int!) {
        deleteShowContainer(id: $id)
    }
`

const createCategoryMutation = gql`
    mutation createProgramTagCategory($data: CreateTagCategory!) {
        createProgramTagCategory(data: $data) {
            id
        }
    }
`

const createTagMutation = gql`
    mutation createProgramTag($data: CreateTag!) {
        createProgramTag(data: $data) {
            id
        }
    }
`
const updateProgramTagMutation = gql`
    mutation updateProgramTag($data: UpdateTag!, $id: ID!) {
        updateProgramTag(data: $data, id: $id) {
            id
        }
    }
`

const deleteProgramTagMutation = gql`
    mutation deleteProgramTag($id: ID!) {
        deleteProgramTag(id: $id)
    }
`

const updateProgramCategoryMutation = gql`
    mutation updateProgramTagCategory($data: UpdateTagCategory!, $id: ID!) {
        updateProgramTagCategory(data: $data, id: $id) {
            id
        }
    }
`

const deleteProgramCategoryMutation = gql`
    mutation deleteProgramTagCategory($id: ID!) {
        deleteProgramTagCategory(id: $id)
    }
`

export const deleteShowContainer = ({ id }: DeleteShowContainerMutationVariables) => {
    const query = graphql.createQuery<
        DeleteShowContainerMutation, DeleteShowContainerMutationVariables
    >(deleteShowContainerMutation)
    return query({ id })
}

export const createProgramCategory = (data: CreateTagCategory) => {
    const query = graphql.createQuery<
        CreateProgramTagCategoryMutation, CreateProgramTagCategoryMutationVariables
    >(createCategoryMutation)
    return query({ data })
}

export const createProgramTag = (data: CreateTag) => {
    const query = graphql.createQuery<
        CreateProgramTagMutation, CreateProgramTagMutationVariables
    >(createTagMutation)
    return query({ data })
}

export const updateProgramTag = ({ text, color, categoryId }, id) => {
    const query = graphql.createQuery<
        UpdateProgramTagMutation, MutationUpdateAttendeeTagArgs
        >(updateProgramTagMutation)
    return query({ data: { text, color, categoryId }, id })
}

export const deleteProgramTag = (id) => {
    const query = graphql.createQuery<
        DeleteProgramTagMutation, DeleteProgramTagMutationVariables
        >(deleteProgramTagMutation)
    return query({ id })
}

export const deleteProgramCategory = (id) => {
    const query = graphql.createQuery<
        DeleteProgramTagCategoryMutation, DeleteProgramTagCategoryMutationVariables
        >(deleteProgramCategoryMutation)
    return query({ id })
}

export const updateProgramTagOrder = (id, order, categoryId) => {
    const query = graphql.createQuery<TagType, MutationUpdateProgramTagArgs>(updateProgramTagMutation)
    return query({ data: { order, categoryId: categoryId || null }, id })
}

export const updateProgramCategoryOrder = (id, order) => {
    const query = graphql.createQuery<
        UpdateProgramTagMutation, MutationUpdateProgramTagCategoryArgs>(updateProgramCategoryMutation)
    return query({ data: { order }, id })
}

export const updateProgramCategory = (id, text) => {
    const query = graphql.createQuery<
        UpdateProgramTagMutation, MutationUpdateProgramTagCategoryArgs>(updateProgramCategoryMutation)
    return query({ data: { text }, id })
}
